import { defineMessages } from "react-intl";

const baseId = "t.components.modals.securityMethodsModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Choose one security methods",
  },
  selectBtn: {
    id: baseId + "selectBtn",
    defaultMessage: "SELECT",
  },
  // title
  mfaRequired: { id: baseId + "mfaRequired", defaultMessage: "arcot's otp" },
  securityQuestionsRequired: {
    id: baseId + "securityQuestionsRequired",
    defaultMessage: "security question",
  },
  uigpOTPRequired: {
    id: baseId + "uigpOTPRequired",
    defaultMessage: "uigp's otp",
  },
  // desc
  uigpOTPRequiredDesc: {
    id: baseId + "uigpOTPRequiredDesc",
    defaultMessage: "Receive the OTP code through SMS or email.",
  },
  mfaRequiredDesc: {
    id: baseId + "mfaRequiredDesc",
    defaultMessage:
      "For using Arcot’s OTP you have download Arcot’s app from Android Play Store app or from iOS AppStore.",
  },
  securityQuestionsRequiredDesc: {
    id: baseId + "securityQuestionsRequiredDesc",
    defaultMessage:
      "Use the security question you have configured into UIGP.\nIf you don’t have configured yet, choose another verify method.",
  },
});
